<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="cancel"
    @cancel="cancel"
    okText="确定"
    width='1000px'
  >
  <template slot="footer">
    <span style="float: left;">共计<span style="color: red;">{{list.length}}</span>个指标</span>
    <a-button @click="cancel">返回</a-button>
  </template>
    <a-table
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :scroll="{y: 350}"
    >
      <span slot="difference" slot-scope="t,record">
        <span style="color:red" v-if="(Number(((record.culationValue||0) - (record.nutritionValue || 0)).toFixed(4)) > 0)">+{{((record.culationValue||0) - (record.nutritionValue || 0)).toFixed(4)}}</span>

        <span style="color:rgba(0, 0, 0, 0.65)" v-if="(Number(((record.culationValue||0) - (record.nutritionValue || 0)).toFixed(4)) === 0) || (!record.nutritionValue && !record.culationValue)">-</span>

        <span style="color:green" v-if="(Number(((record.culationValue||0) - (record.nutritionValue || 0)).toFixed(4)).toFixed(4) < 0)">{{((record.culationValue||0) - (record.nutritionValue || 0)).toFixed(4)}}</span>
      </span>
      <template v-for="el in ['culationValue','nutritionValue']" :slot="el" slot-scope="t">
        {{!t && t !== 0? '' : Number(t).toFixed(4)}}
      </template>
    </a-table>
  </a-modal>
</template>
<script>
export default {
  props:['rawId','equationId','rawName','selectedRows','rawObj'],
  data(){
    return {
      precision:this.$store.state.precision,
      confirmLoading: false,
      visible: false,
      list: [],
      columns: [
        {
          title: '指标名称',
          dataIndex: 'name'
        },
        {
          title: '代码',
          dataIndex: 'code'
        },
        {
          title: '类型',
          dataIndex: 'typeName'
        },
        {
          title: '原先值',
          dataIndex: 'nutritionValue',
          scopedSlots: { customRender: 'nutritionValue' },
        },
        {
          title: '计算值',
          dataIndex: 'culationValue',
          scopedSlots: { customRender: 'culationValue' },
        },
        {
          title: '差异',
          dataIndex: 'difference',
          scopedSlots: { customRender: 'difference' },
        },
        {
          title: '单位',
          dataIndex: 'unit'
        },
      ]
    }
  },
  computed:{
    title(){
      return '查看差异-' + this.rawName
    }
  },
  methods:{
    init(){
      if(!this.equationId && this.equationId !== 0) {
        this.$message.warning('请选择方程式')
        return
      }
      this.modalShow()
      this.getList()
    },
    modalShow(){
      this.visible = !this.visible
    },
    cancel(){
      this.modalShow()
    },
    getList(){
      // this.$http.post('/nhf-app/factorystaffnutritionraw/rawEquationCalculateBackGround',{
      //   equationId:this.equationId,
      //   rawId: this.rawId,
      //   factoryId: window.localStorage.getItem('factoryId')
      // }).then(res => {
      //   let {success,data} = res || {}
      //   if(success) this.list = data || []
      // })
      // let rawNutritionCalculatList = []
      // let list = []
      // list.push(this.rawObj)
      // list.forEach(el => {
      //   let nutritionValues = []
      //   if(el.equationId || el.equationId === 0){
      //     this.selectedRows.forEach(item => {
      //       nutritionValues.push({
      //         "code": item.code,
      //         "id": el[item.code + 'rowId'],
      //         "nutritionId": el[item.code + 'nutritionId'],
      //         "nutritionValue": el[item.code],
      //         "rawId": el[item.code + 'rawId'],
      //         "typeId": el[item.code + 'typeId'],
      //       })
      //     })
        //   rawNutritionCalculatList.push({
        //     equationId: el.equationId,
        //     factoryId: window.localStorage.getItem('factoryId'),
        //     rawId: el.rawId,
        //     nutritionValues
        //   })
        // }
      // })
      
      this.list = []
      let el = this.rawObj
      let nutritionValues = []
      this.selectedRows.forEach(item => {
        nutritionValues.push({
          "code": item.code,
          "id": el[item.code + 'rowId'],
          "nutritionId": el[item.code + 'nutritionId'],
          "nutritionValue": el[item.code],
          "rawId": el[item.code + 'rawId'],
          "typeId": el[item.code + 'typeId'],
        })
      })
      let data = {
        equationId: el.equationId,
        factoryId: window.localStorage.getItem('factoryId'),
        rawId: el.rawId,
        nutritionValues,
      }
      // /factorystaffnutritionraw/rawEquationCalculateBackGroundWithModifyNutritionsValue
      this.$http.post('/nhf-app/factorystaffnutritionraw/rawEquationCalculateBackGroundWithModifyNutritionsValue',data).then(res => {
        let {success,data=[]} = res || {}
        let list = data.filter(el => Number(el.culationValue || 0).toFixed(4) !== Number(el.nutritionValue || 0).toFixed(4))
        if(success) this.list = list || []
      })
    }
  }
}
</script>